import { Instagram } from "lucide-react";
import logo from "@/assets/logo.svg";

const scrollTo = (id: string) => {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
};

const shopLinks = [
  { label: "Focus", target: "meet-the-states" },
  { label: "Sleep", target: "meet-the-states" },
  { label: "Energy", target: "meet-the-states" },
  { label: "Chill", target: "meet-the-states" },
];

const companyLinks = [
  { label: "About", target: "brand-manifesto" },
  { label: "FAQ", target: "faq" },
  { label: "Contact", target: "reserve" },
];

const Footer = () => {
  return (
    <footer className="relative bg-foreground text-background">
      <div className="mx-auto max-w-6xl px-6 pt-16 pb-10">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 md:grid-cols-4 md:gap-8">
          {/* Brand column */}
          <div className="sm:col-span-2 md:col-span-1 flex flex-col items-center md:items-start">
            <img src={logo} alt="State Snacks" className="h-10 brightness-0 invert" loading="lazy" />
            <p className="mt-4 max-w-xs text-xs text-background/50 leading-relaxed text-center md:text-left">
              Functional snacks designed for how you want to feel.
            </p>

            <div className="mt-5 flex items-center gap-4">
              <a href="#" aria-label="Instagram" rel="noopener noreferrer" className="text-background/50 transition-colors hover:text-background">
                <Instagram className="h-4 w-4" strokeWidth={1.5} />
              </a>
              <a href="#" aria-label="TikTok" rel="noopener noreferrer" className="text-background/50 transition-colors hover:text-background">
                <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
                </svg>
              </a>
              <a href="#" aria-label="X / Twitter" rel="noopener noreferrer" className="text-background/50 transition-colors hover:text-background">
                <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4l11.733 16h4.267l-11.733 -16z" />
                  <path d="M4 20l6.768 -6.768m2.46 -2.46L20 4" />
                </svg>
              </a>
            </div>
          </div>

          {/* Shop column */}
          <div>
            <h4 className="text-[11px] font-bold uppercase tracking-[0.15em] text-background">
              Shop
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {shopLinks.map((link) => (
                <li key={link.label}>
                  <button onClick={() => scrollTo(link.target)} className="text-sm text-background/50 transition-colors hover:text-background">
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Company column */}
          <div>
            <h4 className="text-[11px] font-bold uppercase tracking-[0.15em] text-background">
              Company
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {companyLinks.map((link) => (
                <li key={link.label}>
                  <button onClick={() => scrollTo(link.target)} className="text-sm text-background/50 transition-colors hover:text-background">
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter mini */}
          <div>
            <h4 className="text-[11px] font-bold uppercase tracking-[0.15em] text-background">
              Stay in the loop
            </h4>
            <p className="mt-4 text-xs text-background/50 leading-relaxed">
              New states, early drops, and snack science — straight to your inbox.
            </p>
          </div>
        </div>

        <div className="mt-14 border-t border-background/10 pt-6 flex flex-col items-center justify-between gap-4 sm:flex-row">
          <p className="text-xs text-background/30">
            © {new Date().getFullYear()} State Snacks. All Rights Reserved.
          </p>
          <div className="flex gap-6">
            <button className="text-xs text-background/30 transition-colors hover:text-background/50">
              Privacy
            </button>
            <button className="text-xs text-background/30 transition-colors hover:text-background/50">
              Terms
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
